/**
 * TAL module route manifest.
 *
 * Each route is mounted under the shell's main-layout when this module is active
 * (selected by APP_CODE). The shell never knows about TAL pages beyond this file.
 */
export default {
  code: 'tal',
  routes: [
    {
      // Profil détaillé de l'utilisateur connecté (clic sur l'avatar du tiroir,
      // cf. NavigationService.goToPersonalProfil) : statique, donc accessible
      // sans droit sur le menu « Utilisateurs » du produit.
      path: '/tal-my-profile/:userId',
      name: 'tal-my-profile',
      component: () => import('@tal-pages/tal/talUserPersonal.vue'),
      meta: { appCode: 'tal', myProfile: true, appCodes: ['tal', 'talent'] }
    },
    {
      // Vérification publique d'un certificat Open Badges v3 (anonyme).
      path: '/certificate/:uuid',
      name: 'tal-certificate-public',
      component: () => import('@tal-pages/tal/talCertificatePublic.vue'),
      meta: { appCode: 'tal', title: 'Certificat Talent Academy', public: true }
    },
    {
      // Accès « un clic » du candidat invité par un recruteur (?inviteToken=…&next=…), public.
      path: '/candidate-auth',
      name: 'tal-candidate-auth',
      component: () => import('@tal-pages/tal/talCandidateAuth.vue'),
      meta: { appCode: 'tal', title: 'Accès Talent', public: true }
    },
    {
      // « Mes évaluations d'invitation » : route STATIQUE de repli (utilisateur connecté). Le candidat invité peut avoir
      // un compte existant dont le profil n'a pas l'entrée de menu TAL_INVITE_TESTS (donc pas de route dynamique).
      path: '/invite-tests',
      name: 'tal-invite-tests-static',
      component: () => import('@tal-pages/tal/talInviteTests.vue'),
      meta: { appCode: 'tal', title: 'Mes évaluations d’invitation' }
    },
    {
      // Consultation publique d'une shortlist de candidats (le jeton fait office de laissez-passer).
      path: '/shortlist/:token',
      name: 'tal-shortlist-public',
      component: () => import('@tal-pages/tal/talShortlistPublic.vue'),
      meta: { appCode: 'tal', title: 'Shortlist candidats', public: true }
    },
    {
      path: '/tal-portal',
      name: 'tal-portal',
      component: () => import('@tal-pages/portal/talPortal.vue'),
      meta: { appCode: 'tal', title: 'Talent Academy' }
    },
    {
      path: '/academie',
      name: 'tal-academie',
      component: () => import('@tal-pages/tal/talAcademie.vue'),
      meta: { appCode: 'tal', title: 'Académie' }
    },
    {
      path: '/program',
      name: 'tal-program',
      component: () => import('@tal-pages/tal/talProgram.vue'),
      meta: { appCode: 'tal', title: 'Programme' }
    },
    {
      path: '/register',
      name: 'tal-register',
      component: () => import('@tal-pages/tal/talRegister.vue'),
      meta: { appCode: 'tal', title: 'Inscription' }
    },
    {
      path: '/game',
      name: 'tal-game',
      component: () => import('@tal-pages/tal/talGame.vue'),
      meta: { appCode: 'tal', title: 'Quiz' }
    },
    {
      // Parcours d'évaluation principal (sans paiement, sans recrutement), calqué sur Skilloscope.
      path: '/assessment/:quizId',
      name: 'tal-assessment',
      component: () => import('@tal-pages/tal/talAssessment.vue'),
      meta: { appCode: 'tal', title: 'Évaluation' }
    },
    {
      path: '/gallery',
      name: 'tal-gallery',
      component: () => import('@tal-pages/tal/talGallery.vue'),
      meta: { appCode: 'tal', title: 'Galerie' }
    },
  ]
}
